(function() {
  angular.module('cakeInteractiveFilm', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ngResize', 'angulartics.google.analytics']);

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('pageLoading', function(md, $timeout) {
    var PageLoadingController, directive;
    PageLoadingController = function($timeout, $scope, $window) {
      'ngInject';
      this.isYellow = false;
      this.isLogo = false;
      this.isLoadFinished = false;
      this.step = 0;
      this.init = (function(_this) {
        return function() {
          var angle, angleRad, cx, cy, diameter, i, j, radius, ref;
          _this.lineThickness = 3;
          radius = 31;
          console.log(window.innerHeight);
          if (_this.platform.phone) {
            radius = 201;
          }
          diameter = (radius + _this.lineThickness) * 2;
          _this.currentPercentage = 0;
          _this.canvascontainer = document.getElementById('spinner-pixi');
          _this.renderer = new PIXI.CanvasRenderer(diameter, diameter, {
            antialias: true,
            transparent: true,
            resolution: 2
          });
          _this.canvascontainer.appendChild(_this.renderer.view);
          _this.graphics = new PIXI.Graphics();
          _this.graphics.x = _this.graphics.y = radius + _this.lineThickness;
          _this.totalPoints = 120;
          _this.circlePoints = [];
          _this.maxRadius = 360;
          if (_this.platform.phone) {
            _this.maxRadius = 320;
          }
          for (i = j = 0, ref = _this.totalPoints; j <= ref; i = j += 1) {
            angle = Math.round(i / _this.totalPoints * _this.maxRadius);
            angleRad = angle * Math.PI / 180;
            cx = Math.sin(angleRad) * radius;
            cy = -Math.cos(angleRad) * radius;
            _this.circlePoints.push({
              x: cx,
              y: cy
            });
          }
          requestAnimationFrame(_this.animate);
        };
      })(this);
      this.animate = (function(_this) {
        return function() {
          var advancement, divisor, i, j, maxId, ref;
          if (_this.loadingPercentage !== _this.currentPercentage) {
            divisor = 0.01 * (0.1 + _this.currentPercentage * 3);
            if (_this.platform.phone) {
              divisor = 0.01 * (0.1 + _this.currentPercentage * 10);
            }
            advancement = (_this.loadingPercentage - _this.currentPercentage) * divisor;
            _this.currentPercentage += advancement;
            if (!_this.platform.phone) {
              if (_this.currentPercentage > 0.05 && _this.step < 1) {
                _this.step = 1;
                _this.isYellow = true;
                _this.isLogo = true;
              }
              if (_this.currentPercentage > 0.3 && _this.step < 2) {
                _this.step = 2;
                _this.isYellow = false;
              }
              if (_this.currentPercentage > 0.6 && _this.step < 3) {
                _this.step = 3;
                _this.isYellow = true;
              }
              if (_this.currentPercentage > 0.85 && _this.step < 4) {
                _this.step = 4;
                _this.isYellow = false;
              }
            } else {
              if (_this.currentPercentage > 0.25 && _this.step < 1) {
                _this.step = 1;
                _this.isYellow = true;
                _this.isLogo = true;
              }
              if (_this.currentPercentage > 0.5 && _this.step < 2) {
                _this.step = 2;
                _this.isYellow = false;
              }
              if (_this.currentPercentage > 0.67 && _this.step < 3) {
                _this.step = 3;
                _this.isYellow = true;
              }
              if (_this.currentPercentage > 0.85 && _this.step < 4) {
                _this.step = 4;
                _this.isYellow = false;
              }
            }
            if (_this.currentPercentage >= 0.99 && _this.loadingPercentage >= 1 && !_this.isLoadFinished) {
              _this.isLoadFinished = true;
              $timeout(function() {
                return typeof _this.loadFinishedCallback === "function" ? _this.loadFinishedCallback() : void 0;
              }, 2500);
            }
            maxId = Math.floor(_this.currentPercentage * _this.circlePoints.length);
            _this.graphics.lineStyle(_this.lineThickness + 1, 0x070600);
            _this.graphics.moveTo(_this.circlePoints[0].x, _this.circlePoints[0].y);
            for (i = j = 1, ref = maxId; j <= ref; i = j += 1) {
              _this.graphics.lineTo(_this.circlePoints[i].x, _this.circlePoints[i].y);
            }
          }
          _this.renderer.render(_this.graphics);
          if (!_this.isLoadFinished) {
            requestAnimationFrame(_this.animate);
          }
          $timeout(function() {
            return $scope.$apply();
          }, 1);
        };
      })(this);
      this.onStartClick = (function(_this) {
        return function() {
          if (typeof _this.onStartFunction === "function") {
            _this.onStartFunction();
          }
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/pages/loading/page-loading.html',
      controller: PageLoadingController,
      controllerAs: 'pageloading',
      scope: {
        loadingPercentage: '=',
        loadFinishedCallback: '=',
        platform: "="
      },
      bindToController: true,
      replace: true,
      link: function(scope, element) {
        scope.$on('$destroy', function() {
          scope.pageloading.renderer.destroy();
          return scope.pageloading.graphics.destroy();
        });
        return $timeout(function() {
          var loader;
          return loader = PIXI.loader.add('preloader-1', 'assets/images/preloading-logo-title-1.jpg').add('preloader-2', 'assets/images/preloading-logo-title-2.jpg').add('preloader-3', 'assets/images/preloading-logo-title-3.jpg').add('preloader-4', 'assets/images/preloading-logo-title-4.jpg').once('complete', function(loader, resources) {
            return scope.pageloading.init();
          }).load();
        }, 1);
      }
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('pageLanding', function() {
    var PageLandingController, directive;
    PageLandingController = function($scope, $window, $timeout, $rootScope, $sce, md) {
      'ngInject';
      var char, j, k, len, len1, ref, ref1, word;
      this.readyToPlay = false;
      this.landingCopy = 'Once the party is over, Lilah and Echo decide to visit their once best friend, Claire, who just celebrated her birthday with her new boyfriend, Julian, to hand over a little present. ';
      if (!this.platform.phone) {
        this.landingCopy += '<br> Eye for an Eye is one of the 10 editorial fashion films commissioned by Vogue Italia and Fashion Film Festival Milano for the project "Through My Eyes". This innovative collection presents ten of the most important Italian brands seen though the eyes of ten young directors. <br> With this interactive film, Marco Prestini explores the world of Gucci. <br> ';
      }
      this.landingCopy += 'The film premiered during the Vogue Fashion Night Out in Milan in the streets of Via Montenapoleone and was then screened, out of competition, at FFFMilano 2016.';
      this.landingChars = [];
      ref = this.landingCopy.split(' ');
      for (j = 0, len = ref.length; j < len; j++) {
        word = ref[j];
        if (word === '<br>') {
          this.landingChars.push(word);
        } else {
          ref1 = word.split('');
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            char = ref1[k];
            this.landingChars.push(char);
          }
        }
        this.landingChars.push(' ');
      }
      this.animationIndex = -1;
      this.landingStyles = [];
      $timeout((function(_this) {
        return function() {
          var delay, i, l, ref2, results;
          results = [];
          for (i = l = 0, ref2 = _this.landingChars.length - 1; 0 <= ref2 ? l <= ref2 : l >= ref2; i = 0 <= ref2 ? ++l : --l) {
            delay = (0.01 * i) + 's';
            _this.landingStyles[i] = {
              'transition-delay': delay,
              '-webkit-transition-delay': delay,
              '-moz-transition-delay': delay,
              '-o-transition-delay': delay
            };
            results.push(_this.animationIndex = i);
          }
          return results;
        };
      })(this), 500);
      this.onStartClick = (function(_this) {
        return function() {
          if (_this.onStartFunction) {
            _this.readyToPlay = true;
            $rootScope.isVideoStarting = true;
            $timeout(function() {
              _this.onStartFunction();
              return $timeout(function() {
                return $rootScope.isVideoStarting = false;
              }, 1000);
            }, 1300);
          }
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/pages/landing/page-landing.html',
      controller: PageLandingController,
      controllerAs: 'pagelanding',
      scope: true,
      bindToController: {
        onStartFunction: '=',
        videoStart: '=',
        platform: '='
      },
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('pageEnd', function() {
    var PageEndController, directive;
    PageEndController = function($scope, $window) {
      'ngInject';
      this.restart = false;
      this.onRestartClick = (function(_this) {
        return function() {
          _this.showSocial = false;
          _this.restart = true;
          return typeof _this.onRestartFunction === "function" ? _this.onRestartFunction() : void 0;
        };
      })(this);
      this.onShareClick = (function(_this) {
        return function() {
          return _this.showSocial = true;
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/pages/end/page-end.html',
      controller: PageEndController,
      controllerAs: 'pageend',
      scope: {
        onRestartFunction: '='
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('pageCredits', function($timeout) {
    var PageCreditsController, directive;
    PageCreditsController = function($scope, $window, $timeout) {
      'ngInject';
      var pageCredits;
      this.people = [
        {
          title: 'A Film by',
          subtitle: 'Marco Prestini'
        }, {
          title: 'Written by',
          subtitle: 'Alexander Craven & Marco Prestini'
        }, {
          linebreak: true
        }, {
          name: 'Monica Riccioni',
          role: 'Executive Producer'
        }, {
          name: 'Malcolm Duncan',
          role: 'Producer'
        }, {
          name: 'Miranda Lorenz',
          role: 'Production Designer'
        }, {
          name: 'Patrick Meade Jones',
          role: 'Director of Photography'
        }, {
          linebreak: true
        }, {
          title: 'Original Song',
          subtitle: '"Solitude" by Julian Klincewicz'
        }, {
          linebreak: true
        }, {
          name: 'Kendall Walters',
          role: 'Lilah'
        }, {
          name: 'Delilah Parillo',
          role: 'Claire'
        }, {
          name: 'Larsen Thompson',
          role: 'Echo'
        }, {
          name: 'Julian Klincewicz',
          role: 'Julian'
        }, {
          linebreak: true
        }, {
          name: 'Alannah Campion',
          role: 'Line Producer'
        }, {
          name: 'Andrea Gastoque',
          role: 'Line Producer'
        }, {
          name: 'Alexander Craven',
          role: '1st Assistant Producer'
        }, {
          name: 'Emma Massid',
          role: 'Script Supervisor'
        }, {
          linebreak: true
        }, {
          name: 'Madison Krieger',
          role: 'Set Photographer'
        }, {
          name: 'Taylor Robinson',
          role: 'Art Director'
        }, {
          name: 'Rudy Brazziani',
          role: 'Set Decorator'
        }, {
          linebreak: true
        }, {
          name: 'Sean Knight',
          role: 'Stylist'
        }, {
          name: 'Jeffrey Baum',
          role: 'Make up'
        }, {
          name: 'Ryan Taniguchi',
          role: 'Hair'
        }, {
          name: 'Whitney B.',
          role: 'Manicurist'
        }, {
          linebreak: true
        }, {
          name: 'Travis Shannon',
          role: 'First Assistant Camera'
        }, {
          name: 'Scott Sison',
          role: 'Second Assistant Camera'
        }, {
          name: 'Dustin Keindl',
          role: 'Steadycam Operator'
        }, {
          linebreak: true
        }, {
          name: 'Joel Sutherland',
          role: 'Baffer'
        }, {
          name: 'David Nafamuri',
          role: 'Best Boy Electric'
        }, {
          name: 'Jesse Fong',
          role: 'Key Grip'
        }, {
          name: 'Josh Sides',
          role: 'best Boy Grip'
        }, {
          name: 'Brandon Bowen',
          role: 'Swing Grip'
        }, {
          name: 'Justin Frater',
          role: 'Production Sound'
        }, {
          name: 'Joseph Lao',
          role: 'Production Assistant'
        }, {
          linebreak: true
        }, {
          name: 'Guido Smider & Michele Caiati',
          role: 'Original Music & Sound Design'
        }, {
          name: 'Matteo Rebulla',
          role: 'Drummer'
        }, {
          name: 'Julian Klincewicz',
          role: 'Song by'
        }, {
          name: 'Marco Prestini',
          role: 'Editor & Colorist'
        }, {
          name: 'Kian Ansari',
          role: 'Title Designer'
        }, {
          singletitle: 'Interactive Development'
        }, {
          name: 'Francesco Bernabei',
          role: 'Interactive Director'
        }, {
          name: 'Letizia di Battista',
          role: 'Producer Digital'
        }, {
          name: 'Sean Hobman',
          role: 'Art Director Digital'
        }, {
          name: 'David Hartono & Daniele Pelagatti',
          role: 'Interactive Developer'
        }, {
          name: 'Neri Barnini',
          role: 'Developer'
        }
      ];
      pageCredits = document.getElementById('_page-content');
      angular.element(pageCredits).on('webkitAnimationEnd', (function(_this) {
        return function() {
          return typeof _this.onCloseFunction === "function" ? _this.onCloseFunction() : void 0;
        };
      })(this));
      angular.element(pageCredits).on('animationend', (function(_this) {
        return function() {
          return typeof _this.onCloseFunction === "function" ? _this.onCloseFunction() : void 0;
        };
      })(this));
      $scope.$on('$destroy', function() {
        angular.element(pageCredits).off('webkitAnimationEnd');
        return angular.element(pageCredits).off('animationend');
      });
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/pages/credits/page-credits.html',
      controller: PageCreditsController,
      controllerAs: 'credits',
      scope: {
        onCloseFunction: '='
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('videoPlayerYoutube', function(md, $timeout) {
    'ngInject';
    var YtVideoPlaterController, directive;
    YtVideoPlaterController = function(videojs, $scope, $timeout, $window, md) {
      'ngInject';
      this.videoWidth = 1280;
      this.videoHeight = 720;
      $scope.$watch('url', (function(_this) {
        return function(value) {
          _this.dataSetup = {
            techOrder: ["youtube"],
            controls: false,
            sources: [
              {
                type: "video/youtube",
                src: _this.url
              }
            ],
            youtube: {
              iv_load_policy: 3,
              ytControls: 0,
              modestbranding: 1
            }
          };
          $timeout(function() {
            var videoElementId;
            videoElementId = 'video-player-youtube-' + _this.url;
            _this.thePlayer = videojs(videoElementId);
            _this.thePlayer.on('ended', _this.videoEnded);
            return _this.updateVideoStyle();
          }, 1);
        };
      })(this));
      this.updateVideoStyle = (function(_this) {
        return function() {
          var scale;
          scale = Math.max($window.innerWidth / _this.videoWidth, $window.innerHeight / _this.videoHeight);
          _this.vw = _this.videoWidth * scale;
          _this.vh = _this.videoHeight * scale;
          _this.vx = ($window.innerWidth - _this.vw) / 2;
          _this.vy = ($window.innerHeight - _this.vh) / 2;
        };
      })(this);
      this.videoEnded = (function(_this) {
        return function() {
          if (typeof _this.onEndCallback === "function") {
            _this.onEndCallback();
          }
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/video-player-youtube/video-player-youtube.html',
      controller: YtVideoPlaterController,
      controllerAs: 'ytVideoPlayer',
      replace: true,
      bindToController: true,
      scope: {
        url: "@",
        loop: "@",
        autoplay: "@",
        onEndCallback: "="
      }
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('videoPlayer', function(md, $timeout) {
    'ngInject';
    var VideoController, directive;
    VideoController = function(videojs, $scope, $timeout, $window, md, $rootScope) {
      'ngInject';
      this.videoWidth = this.platform.phone ? 480 : 960;
      this.videoHeight = this.platform.phone ? 270 : 540;
      this.thePlayer = null;
      this.videoPlayerReady = false;
      this.lastTime = 0;
      this.lastBuffer = 0;
      this.buffered = false;
      this.bufferPause = false;
      $scope.$watch('videoplayer.videoMute', (function(_this) {
        return function(value) {
          var ref, ref1;
          if (value) {
            return (ref = _this.thePlayer) != null ? ref.volume(0) : void 0;
          } else {
            return (ref1 = _this.thePlayer) != null ? ref1.volume(1) : void 0;
          }
        };
      })(this));
      $scope.$watch('videoplayer.videoRestart', (function(_this) {
        return function(value) {
          if (value) {
            if (!_this.platform.ios) {
              _this.thePlayer.currentTime(0);
              _this.thePlayer.play();
              return _this.updateVideoStyle();
            } else {
              return _this.init();
            }
          }
        };
      })(this));
      $scope.$watch('videoplayer.videoPlay', (function(_this) {
        return function(value) {
          var ref, ref1;
          if (value) {
            if ((ref = _this.thePlayer) != null) {
              ref.play();
            }
            if (_this.thePlayer != null) {
              return $timeout(function() {
                return _this.setVideoElement(_this.thePlayer.tech_.el_);
              }, 2000);
            }
          } else {
            return (ref1 = _this.thePlayer) != null ? ref1.pause() : void 0;
          }
        };
      })(this));
      this.updateVideoStyle = (function(_this) {
        return function() {
          if (_this.videoPlayerReady) {
            _this.videoScale = Math.max($window.innerWidth / _this.videoWidth, $window.innerHeight / _this.videoHeight);
            _this.vw = Math.round(_this.videoWidth * _this.videoScale * 2);
            _this.vh = Math.round(_this.videoHeight * _this.videoScale);
            _this.tx = Math.round(-(_this.vw / 4));
            _this.vx = Math.round(($window.innerWidth - _this.vw) / 2);
            _this.vy = Math.round(($window.innerHeight - _this.vh) / 2);
            _this.thePlayer.tech_.el_.width = _this.vw;
            _this.thePlayer.tech_.el_.height = _this.vh;
            $timeout(function() {
              return $scope.$apply();
            }, 1);
          }
        };
      })(this);
      this.onLoadedData = (function(_this) {
        return function() {
          if (typeof _this.onReadyCallback === "function") {
            _this.onReadyCallback();
          }
          _this.videoEnabled = true;
          _this.videoPlayerReady = true;
          _this.updateVideoStyle();
          if (!_this.platform.ios) {
            $timeout(function() {
              return _this.thePlayer.pause();
            }, 100);
          }
          return $timeout(function() {
            return $scope.$apply();
          }, 1);
        };
      })(this);
      this.videoUpdate = (function(_this) {
        return function() {
          return typeof _this.onProgressCallback === "function" ? _this.onProgressCallback(_this.thePlayer.currentTime(), _this.thePlayer.duration()) : void 0;
        };
      })(this);
      this.videoEnded = (function(_this) {
        return function() {
          _this.thePlayer.currentTime(0);
          if (typeof _this.onEndCallback === "function") {
            _this.onEndCallback();
          }
          if (!_this.staticEnd && !_this.isLooping) {
            $timeout(function() {
              return $scope.$apply();
            }, 1);
          }
          if (_this.isLooping) {
            _this.thePlayer.currentTime(0);
            _this.thePlayer.play();
            return _this.videoHalf = false;
          }
        };
      })(this);
      this.videoProgress = (function(_this) {
        return function() {
          var currentTime, duration;
          currentTime = _this.thePlayer.currentTime();
          duration = _this.thePlayer.duration();
          if (_this.lastTime !== currentTime) {
            return _this.lastTime = currentTime;
          } else if (_this.thePlayer.paused() === false) {
            _this.buffered = false;
            _this.bufferPause = true;
            if (typeof _this.onBufferingCallback === "function") {
              _this.onBufferingCallback();
            }
            return _this.lastBuffer = _this.thePlayer.bufferedPercent();
          } else if (!_this.buffered && (_this.thePlayer.bufferedPercent() - _this.lastBuffer > 0.2 || _this.thePlayer.bufferedPercent() > 0.9)) {
            _this.buffered = true;
            if (_this.bufferPause) {
              if (typeof _this.onBufferFullCallback === "function") {
                _this.onBufferFullCallback();
              }
              return _this.thePlayer.play();
            }
          }
        };
      })(this);
      this.videoIsPlaying = (function(_this) {
        return function() {
          return _this.bufferPause = false;
        };
      })(this);
      this.init = (function(_this) {
        return function() {
          var videoElementId, vids;
          videoElementId = 'video-player-' + _this.videoId;
          _this.thePlayer = videojs(videoElementId);
          _this.thePlayer.on('loadeddata', _this.onLoadedData);
          _this.thePlayer.on('ended', _this.videoEnded);
          _this.thePlayer.on('timeupdate', _this.videoUpdate);
          _this.thePlayer.on('progress', _this.videoProgress);
          _this.thePlayer.on('play', _this.videoIsPlaying);
          _this.thePlayer.volume(1);
          vids = document.getElementsByTagName('video');
          if (_this.platform.ios && _this.platform.phone) {
            return makeVideoPlayableInline(vids[0], false);
          }
        };
      })(this);
      this.setVideoElement = (function(_this) {
        return function(el) {
          _this.videoEl = el;
          $rootScope.videoElementSource = el;
          return $timeout(function() {
            return $scope.$apply();
          }, 1);
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/video-player/video-player.html',
      controller: VideoController,
      controllerAs: 'videoplayer',
      replace: true,
      bindToController: true,
      scope: {
        videoPath: "@",
        platform: "=",
        videoId: "@",
        videoEl: "=",
        staticEnd: "@",
        endCallbackTimer: "@",
        videoVariablePath: "=",
        videoPlay: "=",
        videoMute: "=",
        videoRestart: "=",
        onProgressCallback: "=",
        onEnableClickCallback: "=",
        onDisableClickCallback: "=",
        onBufferingCallback: "=",
        onBufferFullCallback: "=",
        onEndCallback: "=",
        onReadyCallback: "=",
        waitPlay: "@",
        isLooping: "@"
      },
      link: function(scope, element, $rootScope) {
        if (!scope.videoplayer.platform.ios) {
          return $timeout(scope.videoplayer.init, 100);
        }
      }
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('versionInfo', function() {
    var VersionInfoController, directive;
    VersionInfoController = function($http, $scope, $sce) {
      'ngInject';
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/version-info/version-info.html',
      controller: VersionInfoController,
      controllerAs: 'versioninfo',
      scope: {
        info: "="
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('shareButtons', function() {
    var ShareButtonsController, directive;
    ShareButtonsController = function($scope, $window) {
      'ngInject';
      this.openPopup = function(url, width, height) {
        var opts;
        if (url == null) {
          url = null;
        }
        if (width == null) {
          width = 557;
        }
        if (height == null) {
          height = 400;
        }
        opts = 'width=' + width + ', height=' + height + ', scrollbars=0, ' + 'top=' + (($window.innerHeight / 2) - (height / 2)) + ', ' + 'left=' + (($window.innerWidth / 2) - (width / 2));
        return window.open(url, '_blank', opts);
      };
      this.shareFacebook = (function(_this) {
        return function() {
          var path, url;
          url = $window.location.origin;
          path = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url);
          _this.openPopup(path);
        };
      })(this);
      this.shareTwitter = (function(_this) {
        return function() {
          var path, twitter, url;
          url = $window.location;
          twitter = {
            via: null,
            hashtags: ["#eyeforaneye", "#interactivefilm"],
            text: "EyeForAnEye: an interactive film by Marco Prestini produced by FFFM, @vogue_italia and @THINKCATTLEYA"
          };
          path = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(twitter.text);
          if (twitter.via != null) {
            path += '&via=' + twitter.via;
          }
          if (twitter.hashtags != null) {
            path += '&hashtags=' + twitter.hashtags.join(",");
          }
          path += '&url=' + url;
          _this.openPopup(path);
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/share/share-buttons.html',
      controller: ShareButtonsController,
      controllerAs: 'sharebuttons',
      scope: {
        copy: "="
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('instruction', function() {
    var InstructionController, directive;
    InstructionController = function($http, $scope, $sce) {
      'ngInject';
      this.onClick = (function(_this) {
        return function() {
          return _this.onClickAction();
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/instruction/instruction.html',
      controller: InstructionController,
      controllerAs: 'instruction',
      scope: {
        info: '=',
        platform: '=',
        onClickAction: '='
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('headerFooter', function() {
    var HeaderFooterController, directive;
    HeaderFooterController = function($scope, $window) {
      'ngInject';
      this.updateStyle = (function(_this) {
        return function() {
          var progressPos, py, timePos, ty, vh, videoScale, vy;
          videoScale = Math.max($window.innerWidth / 960, $window.innerHeight / 540);
          vh = 540 * videoScale;
          vy = ($window.innerHeight - vh) / 2;
          progressPos = 473;
          py = $window.innerHeight - (vy + (progressPos * videoScale));
          if (py < 0) {
            py = 0;
          }
          if (!_this.platform.phone) {
            _this.progressBottom = py + 'px';
          }
          timePos = 515;
          ty = $window.innerHeight - (vy + (timePos * videoScale));
          if (ty < 25) {
            ty = 25;
          }
          if (!_this.platform.phone) {
            return _this.timeBottom = ty + 'px';
          }
        };
      })(this);
      this.openPopup = function(url, width, height) {
        var opts;
        if (url == null) {
          url = null;
        }
        if (width == null) {
          width = 557;
        }
        if (height == null) {
          height = 400;
        }
        opts = 'width=' + width + ', height=' + height + ', scrollbars=0, ' + 'top=' + (($window.innerHeight / 2) - (height / 2)) + ', ' + 'left=' + (($window.innerWidth / 2) - (width / 2));
        return window.open(url, '_blank', opts);
      };
      this.shareFacebook = (function(_this) {
        return function() {
          var path, url;
          url = $window.location;
          path = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url);
          _this.openPopup(path);
        };
      })(this);
      this.shareTwitter = (function(_this) {
        return function() {
          var path, twitter, url;
          url = $window.location;
          twitter = {
            via: null,
            hashtags: _this.copy.share.twitter.hashtags.split(" "),
            text: _this.copy.share.twitter.text
          };
          path = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(twitter.text);
          if (twitter.via != null) {
            path += '&via=' + twitter.via;
          }
          if (twitter.hashtags != null) {
            path += '&hashtags=' + twitter.hashtags.join(",");
          }
          path += '&url=' + url;
          _this.openPopup(path);
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/header-footer/header-footer.html',
      controller: HeaderFooterController,
      controllerAs: 'headerfooter',
      scope: {
        copy: '=',
        onCreditsClick: '=',
        showFooter: '=',
        showVideoTime: '=',
        showHeader: '=',
        showShare: '=',
        videoMinutes: '=',
        videoPercent: '=',
        videoHeight: '=',
        videoStart: '=',
        videoY: '=',
        platform: '='
      },
      bindToController: true,
      replace: true
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').directive('canvasTransition', function(md, $timeout) {
    'ngInject';
    var CanvasTransitionController, directive;
    CanvasTransitionController = function(PIXI, $scope, $timeout, $window, md, $rootScope) {
      'ngInject';
      this.videoWidth = this.platform.phone ? 480 : 960;
      this.videoHeight = this.platform.phone ? 270 : 540;
      this.initialized = false;
      this.canvascontainer = null;
      $scope.$watch('canvastransition.videoSource', (function(_this) {
        return function(value) {
          if (value) {
            _this.init(value, _this.canvascontainer);
          }
        };
      })(this));
      $scope.$watch('canvastransition.doupdate', (function(_this) {
        return function(value) {
          if (value) {
            requestAnimationFrame(_this.animate);
          }
        };
      })(this));
      this.updateStyle = (function(_this) {
        return function() {
          var ref, scale, ticker;
          scale = Math.max($window.innerWidth / _this.videoWidth, $window.innerHeight / _this.videoHeight);
          _this.vw = $window.innerWidth;
          _this.vh = $window.innerHeight;
          _this.tx = 0;
          _this.vx = 0;
          _this.vy = 0;
          if ((ref = _this.videoTexture) != null) {
            ref.baseTexture.autoUpdate = false;
          }
          if (_this.videoSprite && _this.renderer) {
            _this.renderer.resize(_this.vw, _this.vh);
            _this.videoSprite.width = Math.round((_this.videoWidth * 2) * scale);
            _this.videoSprite.height = Math.round(_this.videoHeight * scale);
            _this.videoSprite.x = Math.round((_this.vw - (_this.videoSprite.width * 0.5)) / 2);
            _this.videoSprite.y = Math.round((_this.vh - _this.videoSprite.height) / 2);
          }
          ticker = PIXI.ticker.shared;
          ticker.autoStart = false;
          ticker.stop();
          return $timeout(function() {
            return $scope.$apply();
          }, 1);
        };
      })(this);
      this.init = (function(_this) {
        return function(videoSource, canvasContainer) {
          if (!_this.initialized && (videoSource != null) && (canvasContainer != null)) {
            _this.initialized = true;
            _this.renderer = new PIXI.CanvasRenderer(_this.vw, _this.vh, {
              antialias: false,
              transparent: false
            });
            _this.canvascontainer.appendChild(_this.renderer.view);
            _this.videoTexture = PIXI.Texture.fromVideo(videoSource, PIXI.SCALE_MODES.LINEAR);
            _this.videoTexture.baseTexture.autoUpdate = false;
            _this.videoTexture.baseTexture.mipmap = false;
            _this.videoSprite = new PIXI.Sprite(_this.videoTexture);
            requestAnimationFrame(_this.animate);
            $timeout(_this.updateStyle, 1000);
          }
        };
      })(this);
      this.animate = (function(_this) {
        return function() {
          _this.videoTexture.baseTexture.autoUpdate = false;
          if (_this.doupdate) {
            _this.videoTexture.baseTexture.update();
            _this.renderer.render(_this.videoSprite);
            return requestAnimationFrame(_this.animate);
          }
        };
      })(this);
    };
    return directive = {
      restrict: 'E',
      templateUrl: 'app/components/canvas-transition/canvas-transition.html',
      controller: CanvasTransitionController,
      controllerAs: 'canvastransition',
      replace: true,
      bindToController: true,
      scope: {
        videoSource: "=",
        platform: "=",
        doupdate: "="
      },
      link: function(scope, element) {
        return $timeout(function() {
          scope.canvastransition.canvascontainer = element[0].children[0];
          return scope.canvastransition.init(scope.canvastransition.videoSource, scope.canvastransition.canvascontainer);
        }, 1);
      }
    };
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').controller('MainController', function($scope, $timeout, $log, md, createjs, $window, $analytics, $rootScope) {
    'ngInject';
    this.info = {
      version: "0.0.22",
      date: moment(1475161703619).fromNow(),
      ci_build: true,
      ci_commit: '5897ccba8d67418fd844a8ac8f4284b1bdbd2e65',
      ci_author: 'nbarnini',
      ci_branch: 'production'
    };
    this.platform = {
      development: false,
      videosPath: "assets/videos",
      desktop: !md.mobile() && !md.phone() && !md.tablet(),
      mobile: md.mobile() != null,
      phone: md.phone() != null,
      tablet: md.tablet() != null,
      edge: !!/Edge\/\d+/i.test(navigator.userAgent),
      ios: md.os() === "iOS"
    };
    if (this.platform.mobile) {
      this.platform.videosPath = "assets/videos-mobile";
    }
    if (this.platform.tablet && this.platform.ios) {
      this.platform.videosPath = "assets/videos";
    }
    this.videoIsStarting = false;
    this.videoIsPlaying = false;
    this.videoStateFirst = false;
    this.videoIsFinished = false;
    this.videoIsYellow = false;
    this.firstVideoAnimation = '';
    this.secondVideoAnimation = '';
    $rootScope.isVideoStarting = false;
    this.isVideoStarting = false;
    $scope.$watch(function() {
      return $rootScope.isVideoStarting;
    }, (function(_this) {
      return function(currentStarting) {
        return _this.isVideoStarting = currentStarting;
      };
    })(this));
    this.transition = {
      speed: '0.5s',
      scaleMin: 0.5,
      scaleMax: 1.5,
      blur: '5px'
    };
    this.state = '';
    this.showLoading = true;
    this.showLanding = false;
    this.showCredits = false;
    this.showInstruction = false;
    this.showRotate = false;
    this.showEnd = false;
    this.blockInstruction = false;
    this.enableClick = false;
    this.headerVisible = false;
    this.footerVisible = false;
    this.shareVisible = true;
    this.videoBufferingPromise = null;
    this.videoTimeVisible = false;
    this.loadingPercentage = 0;
    this.onMouseMove = (function(_this) {
      return function() {
        if (_this.videoIsStarting && _this.videoIsPlaying && !_this.platform.mobile) {
          _this.showShare();
          $timeout.cancel(_this.hideSharePromise);
          return _this.hideSharePromise = $timeout(_this.hideShare, 7000);
        }
      };
    })(this);
    this.showShare = (function(_this) {
      return function() {
        return _this.shareVisible = true;
      };
    })(this);
    this.hideShare = (function(_this) {
      return function() {
        return _this.shareVisible = false;
      };
    })(this);
    this.onVideoEnd = (function(_this) {
      return function() {
        var ref, ref1;
        _this.videoIsFinished = true;
        _this.videoIsPlaying = false;
        _this.videoIsStarting = false;
        _this.shareVisible = false;
        _this.showEnd = true;
        if ((ref = _this.secondSound) != null) {
          ref.paused = true;
        }
        if ((ref1 = _this.firstSound) != null) {
          ref1.paused = true;
        }
        _this.videoTimeVisible = false;
        _this.firstVideoAnimation = '';
        _this.secondVideoAnimation = '';
        _this.videoIsYellow = false;
        _this.blockInstruction = false;
        _this.videoCurrentTime = 0;
        return _this.videoPercent = '0px';
      };
    })(this);
    this.hideInstruction = (function(_this) {
      return function() {
        _this.blockInstruction = true;
        return _this.showInstruction = false;
      };
    })(this);
    this.onVideoProgress = (function(_this) {
      return function(currentTime, duration) {
        var sec;
        _this.videoCurrentTime = currentTime;
        _this.videoDuration = duration;
        _this.videoPercent = Math.floor((currentTime / duration) * $window.innerWidth) + 'px';
        sec = Math.floor(currentTime % 60);
        if (sec < 10) {
          sec = '0' + sec;
        }
        _this.videoMinutes = Math.floor(currentTime / 60) + ':' + sec;
        if (_this.videoCurrentTime > 166 && !_this.videoIsYellow) {
          _this.videoIsYellow = true;
        }
        if (_this.videoCurrentTime > 30 && !_this.enableClick) {
          _this.enableClick = true;
        }
        if (_this.videoCurrentTime > 161 && _this.enableClick) {
          _this.enableClick = false;
        }
        if (_this.videoCurrentTime > 30 && !_this.showInstruction) {
          if (!_this.blockInstruction) {
            _this.showInstruction = true;
          }
        }
        if (_this.videoCurrentTime > 34 && _this.showInstruction) {
          _this.showInstruction = false;
        }
        return $timeout(function() {
          return $scope.$apply();
        }, 1);
      };
    })(this);
    this.onVideoClick = (function(_this) {
      return function(event) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        if (_this.enableClick) {
          $analytics.eventTrack('videoSwitch');
          _this.videoStateFirst = !_this.videoStateFirst;
          if (_this.videoStateFirst) {
            if (_this.platform.mobile) {
              _this.firstVideoAnimation = 'animation-mobile-first-out';
              _this.secondVideoAnimation = 'animation-mobile-second-in';
            } else {
              _this.firstVideoAnimation = 'animation-video-first-out';
              _this.secondVideoAnimation = 'animation-video-second-in';
            }
            if ((ref = _this.secondSound) != null) {
              ref.volume = 0;
            }
            if ((ref1 = _this.firstSound) != null) {
              ref1.volume = 1;
            }
            if (_this.platform.mobile) {
              if ((ref2 = _this.secondSound) != null) {
                ref2.paused = true;
              }
              if ((ref3 = _this.firstSound) != null) {
                ref3.paused = false;
              }
              return (ref4 = _this.firstSound) != null ? ref4.position = _this.videoCurrentTime * 1000 : void 0;
            }
          } else {
            if (_this.platform.mobile) {
              _this.firstVideoAnimation = 'animation-mobile-first-in';
              _this.secondVideoAnimation = 'animation-mobile-second-out';
            } else {
              _this.firstVideoAnimation = 'animation-video-first-in';
              _this.secondVideoAnimation = 'animation-video-second-out';
            }
            if ((ref5 = _this.secondSound) != null) {
              ref5.volume = 1;
            }
            if ((ref6 = _this.firstSound) != null) {
              ref6.volume = 0;
            }
            if (_this.platform.mobile) {
              if ((ref7 = _this.secondSound) != null) {
                ref7.paused = false;
              }
              if ((ref8 = _this.firstSound) != null) {
                ref8.paused = true;
              }
              return (ref9 = _this.secondSound) != null ? ref9.position = _this.videoCurrentTime * 1000 : void 0;
            }
          }
        }
      };
    })(this);
    this.onAudioClick = function() {
      return console.log('audio');
    };
    this.onCreditsClick = (function(_this) {
      return function() {
        return $timeout(function() {
          var ref, ref1, ref2, ref3, ref4, ref5;
          _this.showCredits = !_this.showCredits;
          if (_this.videoIsStarting) {
            _this.videoIsPlaying = !_this.videoIsPlaying;
            if (_this.videoIsPlaying) {
              if (_this.platform.mobile) {
                if ((ref = _this.secondSound) != null) {
                  ref.paused = _this.videoStateFirst;
                }
                return (ref1 = _this.firstSound) != null ? ref1.paused = !_this.videoStateFirst : void 0;
              } else {
                if ((ref2 = _this.secondSound) != null) {
                  ref2.paused = false;
                }
                return (ref3 = _this.firstSound) != null ? ref3.paused = false : void 0;
              }
            } else {
              if ((ref4 = _this.secondSound) != null) {
                ref4.paused = true;
              }
              return (ref5 = _this.firstSound) != null ? ref5.paused = true : void 0;
            }
          }
        });
      };
    })(this);
    this.onResize = function(event) {
      if (this.platform.mobile && $window.innerWidth < $window.innerHeight) {
        this.showRotate = true;
      } else {
        this.showRotate = false;
      }
    };
    this.startVideo = (function(_this) {
      return function() {
        var isIOSTablet, ref, ref1, ref2, ref3;
        _this.showEnd = false;
        _this.videoIsFinished = false;
        _this.showLanding = false;
        _this.videoIsStarting = true;
        _this.videoIsPlaying = true;
        _this.footerVisible = true;
        _this.shareVisible = true;
        _this.headerVisible = false;
        _this.videoTimeVisible = true;
        _this.videoIsYellow = false;
        if ((ref = _this.secondSound) != null) {
          ref.stop();
        }
        if ((ref1 = _this.firstSound) != null) {
          ref1.stop();
        }
        _this.firstSound = createjs.Sound.play("sound1");
        _this.firstSound.volume = 0;
        isIOSTablet = false;
        if (_this.platform.ios && _this.platform.tablet) {
          isIOSTablet = true;
        }
        if (_this.platform.mobile) {
          if (!isIOSTablet) {
            _this.secondSound = createjs.Sound.play("sound2");
            _this.secondSound.volume = 1;
            if ((ref2 = _this.secondSound) != null) {
              ref2.paused = false;
            }
          }
          if ((ref3 = _this.firstSound) != null) {
            ref3.paused = true;
          }
        }
        $timeout(function() {
          return $scope.$apply();
        }, 10);
        if (_this.platform.mobile) {
          return $timeout(function() {
            var ref4, ref5;
            if ((ref4 = _this.firstSound) != null) {
              ref4.position = _this.videoCurrentTime * 1000;
            }
            return (ref5 = _this.secondSound) != null ? ref5.position = _this.videoCurrentTime * 1000 : void 0;
          }, 3000);
        }
      };
    })(this);
    this.onVideoBuffering = (function(_this) {
      return function() {
        var ref, ref1;
        if (!_this.platform.mobile) {
          if ((ref = _this.secondSound) != null) {
            ref.paused = true;
          }
          if ((ref1 = _this.firstSound) != null) {
            ref1.paused = true;
          }
        }
      };
    })(this);
    this.onVideoBufferFull = (function(_this) {
      return function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if ((ref = _this.secondSound) != null) {
          ref.position = _this.videoCurrentTime * 1000;
        }
        if ((ref1 = _this.firstSound) != null) {
          ref1.position = _this.videoCurrentTime * 1000;
        }
        if (!_this.platform.mobile) {
          if ((ref2 = _this.secondSound) != null) {
            ref2.paused = false;
          }
          if ((ref3 = _this.firstSound) != null) {
            ref3.paused = false;
          }
        } else {
          if ((ref4 = _this.secondSound) != null) {
            ref4.paused = _this.videoStateFirst;
          }
          if ((ref5 = _this.firstSound) != null) {
            ref5.paused = !_this.videoStateFirst;
          }
        }
        return;
      };
    })(this);
    this.loadFirstImages = (function(_this) {
      return function() {
        var i, len, path, queue, ref, url;
        _this.firstImageLoaded = 0;
        queue = new createjs.LoadQueue(true);
        queue.on('progress', _this.firstImageProgress, _this);
        queue.on('complete', _this.firstImageComplete, _this);
        _this.firstAssets = ['preloading-logo-title-1.jpg', 'preloading-logo-title-2.jpg', 'preloading-logo-title-3.jpg', 'preloading-logo-title-4.jpg', 'sprites/sprite.png', 'end-page-background.png', 'credits-claire.png', 'credits-echo.png', 'credits-julian.png', 'credits-lilah.png', 'sprites/sprite.png'];
        path = 'assets/images/';
        ref = _this.firstAssets;
        for (i = 0, len = ref.length; i < len; i++) {
          url = ref[i];
          queue.loadFile({
            src: path + url,
            type: createjs.AbstractLoader.BINARY
          });
        }
        return queue.load();
      };
    })(this);
    this.firstImageProgress = (function(_this) {
      return function(evt) {
        return _this.loadingPercentage = evt.loaded * 0.25;
      };
    })(this);
    this.firstImageComplete = (function(_this) {
      return function() {
        _this.firstImageCompleted = true;
        return _this.checkVideo();
      };
    })(this);
    this.onVideoReady = (function(_this) {
      return function() {
        _this.videoIsReady = true;
        return _this.checkVideo();
      };
    })(this);
    this.checkVideo = (function(_this) {
      return function() {
        if (_this.firstImageCompleted && _this.videoIsReady || _this.platform.ios) {
          _this.loadingPercentage = 0.25;
          return _this.loadSecondImages();
        }
      };
    })(this);
    this.loadSecondImages = (function(_this) {
      return function() {
        var path, queue;
        _this.secondImageLoaded = 0;
        queue = new createjs.LoadQueue(true);
        queue.on('progress', _this.secondImageProgress, _this);
        queue.on('complete', _this.secondImageComplete, _this);
        queue.installPlugin(createjs.Sound);
        queue.setMaxConnections(10);
        path = 'assets/images/';
        if (_this.platform.phone) {
          queue.loadFile({
            src: 'assets/audio/audio-exterior-1.mp3',
            id: 'sound1'
          });
          queue.loadFile({
            src: 'assets/audio/audio-interior-2.mp3',
            id: 'sound2'
          });
        } else {
          queue.loadFile({
            src: 'assets/audio/audio-exterior-1.mp3',
            id: 'sound1'
          });
          queue.loadFile({
            src: 'assets/audio/audio-interior-2.mp3',
            id: 'sound2'
          });
        }
        return queue.load();
      };
    })(this);
    this.secondImageProgress = (function(_this) {
      return function(evt) {
        return _this.loadingPercentage = 0.25 + (evt.loaded * 0.75);
      };
    })(this);
    this.secondImageComplete = function(evt) {};
    this.loadFirstImages();
    this.loadFinished = (function(_this) {
      return function() {
        _this.showLoading = false;
        _this.footerVisible = true;
        _this.headerVisible = true;
        return _this.showLanding = true;
      };
    })(this);
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').run(function($log, Modernizr, md) {
    'ngInject';
    Modernizr.addTest({
      mobile: !!md.mobile(),
      phone: !!md.phone(),
      tablet: !!md.tablet(),
      android: !!md.is('AndroidOS'),
      ios: !!md.is('iOS'),
      ipad: !!md.is('iPad'),
      iphone: !!md.is('iPhone'),
      wphone: !!md.is('WindowsPhoneOS'),
      mobilegradea: md.mobileGrade() === 'A',
      edge: !!/Edge\/\d+/i.test(navigator.userAgent),
      firefox: md.version('Gecko') > 1
    });
    Modernizr.addTest('volume', function() {
      var test;
      test = document.createElement('audio');
      test.volume = 0.5;
      return Modernizr.audio && test.volume === 0.5;
    });
    return PIXI.utils._saidHello = true;
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    $stateProvider.state('home', {
      url: '/',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main'
    });
    return $urlRouterProvider.otherwise('/');
  });

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').constant('moment', moment).constant('Modernizr', Modernizr).constant('md', new MobileDetect(navigator.userAgent)).constant('videojs', videojs).constant('createjs', createjs).constant('PIXI', PIXI);

}).call(this);



(function() {
  angular.module('cakeInteractiveFilm').config(function($logProvider) {
    'ngInject';
    return $logProvider.debugEnabled(true);
  });

}).call(this);



angular.module("cakeInteractiveFilm").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div ng-resize=main.onResize($event) class=main-container ng-class=\"{\'video-yellow\' : main.videoIsYellow, \'section-video\': main.videoIsStarting}\" ng-animate-children ng-mousemove=main.onMouseMove()><div class=video-container ng-show=main.videoIsStarting ng-click=main.onVideoClick()><div class=video-wrapper ng-style=\"{\n      webkitAnimationName:main.firstVideoAnimation,\n      animationName:main.firstVideoAnimation,\n      }\"><video-player platform=main.platform video-id=test video-play=main.videoIsPlaying video-restart=main.videoIsStarting on-ready-callback=main.onVideoReady on-end-callback=main.onVideoEnd on-buffering-callback=main.onVideoBuffering on-buffer-full-callback=main.onVideoBufferFull on-progress-callback=main.onVideoProgress video-path=\"{{main.platform.videosPath+\'/cake\'}}\" video-el=main.videoEl video-mute=main.videoStateFirst></video-player></div><div class=\"video-wrapper hide\" ng-style=\"{\n      animationName:main.secondVideoAnimation,\n      webkitAnimationName:main.secondVideoAnimation,\n    }\"><canvas-transition platform=main.platform video-is-playing=main.videoIsPlaying doupdate=main.videoStateFirst video-source=main.videoEl></canvas-transition></div></div><instruction platform=main.platform on-click-action=main.hideInstruction ng-if=main.showInstruction></instruction><page-loading ng-if=main.showLoading loading-percentage=main.loadingPercentage load-finished-callback=main.loadFinished class=page platform=main.platform></page-loading><page-landing on-start-function=main.startVideo video-start=main.isVideoStarting platform=main.platform ng-if=main.showLanding class=page></page-landing><page-end ng-if=main.showEnd class=page on-restart-function=main.startVideo></page-end><header-footer show-video-time=main.videoTimeVisible show-footer=main.footerVisible show-header=main.headerVisible show-share=main.shareVisible video-start=main.isVideoStarting on-credits-click=main.onCreditsClick on-audio-click=main.onAudioClick video-percent=main.videoPercent video-minutes=main.videoMinutes platform=main.platform></header-footer><page-credits on-close-function=main.onCreditsClick ng-show=main.showCredits class=page></page-credits><!-- <video-playe url=\"http://www.youtube.com/watch?v=Z47xwzYGop8\" autoplay loop></video-player-youtube>--><version-info ng-if=main.platform.development info=main.info></version-info><div class=rotate-device ng-if=main.showRotate><div class=icon-rotate-device></div><p>Please rotate your device</p></div><!--<div class=\"transition-control\">\n    <label>Speed</label>\n    <input type=\"text\" name=\"input-speed\" ng-model=\"main.transition.speed\">\n    <label>Scale Min</label>\n    <input type=\"text\" name=\"input-scale\" ng-model=\"main.transition.scaleMin\">\n    <label>Scale Max</label>\n    <input type=\"text\" name=\"input-scale\" ng-model=\"main.transition.scaleMax\">\n    <label>Blur</label>\n    <input type=\"text\" name=\"input-scale\" ng-model=\"main.transition.blur\">\n  </div>--></div>");
$templateCache.put("app/components/canvas-transition/canvas-transition.html","<div ng-resize=canvastransition.updateStyle($event)><div class=canvas-transition ng-style=\"{\n      top:canvastransition.vy+\'px\',\n      left:canvastransition.vx+\'px\',\n      width: canvastransition.vw+\'px\',\n      height:canvastransition.vh+\'px\',\n      webkitTransform:\'translateX(\'+canvastransition.tx+\'px)\',\n      transform:\'translateX(\'+canvastransition.tx+\'px)\'\n      }\"></div></div>");
$templateCache.put("app/components/header-footer/header-footer.html","<div ng-resize=headerfooter.updateStyle($event) class=header-footer ng-class=\"{\'transition-in-progress\': headerfooter.videoStart}\" ng-animate-children><div class=header ng-show=headerfooter.showHeader><div id=logo>EYE FOR AN EYE</div></div><div class=footer ng-show=headerfooter.showFooter><share-buttons ng-show=headerfooter.showShare></share-buttons><div class=footer-progress-bar ng-show=headerfooter.showVideoTime ng-style=\"{\n      \'width\':headerfooter.videoPercent,\n      \'bottom\':headerfooter.progressBottom}\"></div><div class=footer-minute ng-show=headerfooter.showVideoTime ng-style=\"{\n      \'bottom\':headerfooter.timeBottom}\">{{headerfooter.videoMinutes}}</div><div ng-show=headerfooter.showShare class=footer-menu-container><div class=footer-menu ng-click=headerfooter.onCreditsClick() analytics-on=click analytics-event=Credits>CREDITS</div><!-- <div class=\"footer-menu\" ng-click=\"headerfooter.onAudioClick()\">AUDIO</div> --></div></div></div>");
$templateCache.put("app/components/instruction/instruction.html","<div class=instruction ng-click=instruction.onClick()><div class=background></div><div class=instruction-content><div class=screen-back></div><div class=screen-front></div><div class=screen-arrow></div><p ng-if=!instruction.platform.mobile>Click to change perspective</p><p ng-if=instruction.platform.mobile>Tap to change perspective</p></div></div>");
$templateCache.put("app/components/share/share-buttons.html","<div class=share-buttons><div class=share-facebook analytics-on=click analytics-event=ShareFacebook ng-click=sharebuttons.shareFacebook() ng-class=\"{\'complete\':!sharebuttons.iconsOnly}\"><i class=icon-facebook></i></div><div class=share-twitter analytics-on=click analytics-event=ShareTwitter ng-click=sharebuttons.shareTwitter() ng-class=\"{\'complete\':!sharebuttons.iconsOnly}\"><i class=icon-twitter></i></div><p ng-class=\"{\'complete\':!sharebuttons.iconsOnly}\">{{sharebuttons.copy.general.share}}</p></div>");
$templateCache.put("app/components/version-info/version-info.html","<div class=version-info><span ng-if=!versioninfo.info.ci_build>v{{versioninfo.info.version}}+local built {{versioninfo.info.date}}</span> <span ng-if=versioninfo.info.ci_build>v{{versioninfo.info.version}}+git{{versioninfo.info.ci_commit}} built {{versioninfo.info.date}} by {{versioninfo.info.ci_author}} on {{versioninfo.info.ci_branch}}</span></div>");
$templateCache.put("app/components/video-player/video-player.html","<div ng-resize=videoplayer.updateVideoStyle($event) class=\"video-player-container fullscreen\" ng-class=\"{\'is-hidden\':!videoplayer.videoEnabled, \'showing\': videoplayer.videoEnabled}\" ng-style=\"{\n    top:videoplayer.vy+\'px\',\n    left:videoplayer.vx+\'px\',\n    width:videoplayer.vw+\'px\',\n    height:videoplayer.vh+\'px\',\n    webkitTransform: \'translateX(\'+videoplayer.tx+\'px)\',\n    transform: \'translateX(\'+videoplayer.tx+\'px)\'\n  }\"><video ng-attr-id=\"{{\'video-player-\'+videoplayer.videoId}}\" class=\"video-js vjs-default-skin IIV\" preload=auto width={{videoplayer.videoWidth}} height={{videoplayer.videoHeight}} data-setup=\'{\"autoplay\":false}\' ng-if=!videoplayer.platform.mobile><source ng-src=\"{{videoplayer.videoPath+\'.mp4\'}}\" type=video/mp4><source ng-src=\"{{videoplayer.videoPath+\'.webm\'}}\" type=video/webm><source ng-src=\"{{videoplayer.videoPath+\'.ogv\'}}\" type=video/ogg></video><video playsinline muted ng-attr-id=\"{{\'video-player-\'+videoplayer.videoId}}\" class=\"video-js vjs-default-skin IIV\" preload=auto width={{videoplayer.videoWidth}} height={{videoplayer.videoHeight}} data-setup=\'{\"autoplay\":false}\' ng-if=videoplayer.platform.mobile><source ng-src=\"{{videoplayer.videoPath+\'.mp4\'}}\" type=video/mp4><source ng-src=\"{{videoplayer.videoPath+\'.webm\'}}\" type=video/webm><source ng-src=\"{{videoplayer.videoPath+\'.ogv\'}}\" type=video/ogg></video></div>");
$templateCache.put("app/components/video-player-youtube/video-player-youtube.html","<div class=video-player-youtube ng-resize=ytVideoPlayer.updateVideoStyle($event) ng-style=\"{\'top\':ytVideoPlayer.vy+\'px\', \'left\':ytVideoPlayer.vx+\'px\', \'width\': ytVideoPlayer.vw+\'px\', \'height\':ytVideoPlayer.vh+\'px\'}\"><video ng-attr-id=\"{{\'video-player-youtube-\'+ytVideoPlayer.url}}\" ng-attr-data-setup={{ytVideoPlayer.dataSetup}} width=100% height=100% ng-attr-autoplay={{ytVideoPlayer.autoplay}} ng-attr-loop={{ytVideoPlayer.loop}}></video><!-- cover up youtube interface --><div class=video-player-youtube-overlay ng-style=\"{\'top\':ytVideoPlayer.vy+\'px\', \'left\':ytVideoPlayer.vx+\'px\', \'width\': ytVideoPlayer.vw+\'px\', \'height\':ytVideoPlayer.vh+\'px\'}\"></div></div>");
$templateCache.put("app/pages/credits/page-credits.html","<div id=page-credits ng-click=credits.onCloseFunction()><div class=page-content id=_page-content><div class=eye-for-an-eye-logo></div><div class=polaroid-container><div class=\"polaroid polaroid-1\"></div><div class=\"polaroid polaroid-4\"></div><div class=\"polaroid polaroid-7\"></div><div class=\"polaroid polaroid-8\"></div><div class=\"polaroid polaroid-9\"></div><div class=\"polaroid polaroid-10\"></div><div class=\"polaroid polaroid-11\"></div><div class=\"polaroid polaroid-12\"></div></div><div class=credits-images-characters><img src=../../../assets/images/credits-claire.png class=character-claire> <img src=../../../assets/images/credits-echo.png class=character-echo> <img src=../../../assets/images/credits-lilah.png class=character-lilah> <img src=../../../assets/images/credits-julian.png class=character-julian></div><div class=credits-list-container><div class=credits-entry ng-repeat=\"entry in credits.people track by $index\"><div ng-if=entry.title><p class=credits-entry-title>{{::entry.title}}</p><p class=credits-entry-subtitle>{{::entry.subtitle}}</p></div><div ng-if=entry.name><p class=credits-entry-role>{{::entry.role}}</p><p class=credits-entry-name>{{::entry.name}}</p></div><div ng-if=entry.linebreak class=linebreak></div><div ng-if=entry.singletitle class=singletitle>{{::entry.singletitle}}</div></div></div><div class=credits-sponsor-container><div class=credits-logo></div><div class=credits-thanks>Special Thanks</div><div class=credits-thanks-names><span>Clara Del Nero</span> <span>Corneli Jones</span> <span>Delfina D\'Elletrez</span> <span>Sara Maino</span> <span>The Way We Wore</span></div><div class=credits-sponsors><div class=credits-sponsor-1></div><div class=credits-sponsor-2></div><div class=credits-sponsor-3></div><div class=credits-sponsor-4></div><br><div class=credits-sponsor-5></div><div class=credits-sponsor-6></div></div></div></div></div>");
$templateCache.put("app/pages/end/page-end.html","<div id=page-end ng-class=\"{\'page-end-hide\': pageend.restart }\"><div class=page-content><div class=\"button button-replay\" analytics-on=click analytics-event=Restart ng-click=pageend.onRestartClick()><span>Replay Video</span></div><div class=\"button button-share\" ng-class=\"{\'share-active\': pageend.showSocial}\" analytics-on=click analytics-event=ShareGeneral ng-click=pageend.onShareClick()><share-buttons></share-buttons><span>Share</span></div></div></div>");
$templateCache.put("app/pages/landing/page-landing.html","<div id=page-landing ng-class=\"{\'ready-to-play\': pagelanding.readyToPlay }\"><div class=sliding-background></div><div class=sliding-black></div><div class=page-content><p id=page-landing-copy><span class=copy-span ng-class=\"{\'char-fade-in\': pagelanding.animationIndex >= $index}\" ng-repeat=\"char in pagelanding.landingChars track by $index\" ng-style=pagelanding.landingStyles[$index] ng-bind-html=char></span></p><p class=copy-start>Start The Experience</p><div class=\"button button-start\" analytics-on=click analytics-event=StartExperience ng-click=pagelanding.onStartClick()>→</div></div></div>");
$templateCache.put("app/pages/loading/page-loading.html","<div id=page-loading ng-class=\"{\'page-loaded\': pageloading.isLoadFinished}\"><div class=\"page-step black\" ng-show=\"pageloading.step == 4\"><img id=preloading-title-4 class=preloading-title src=assets/images/preloading-logo-title-4.jpg></div><div class=\"page-step yellow\" ng-show=\"pageloading.step == 3\"><img id=preloading-title-3 class=preloading-title src=assets/images/preloading-logo-title-3.jpg></div><div class=\"page-step black\" ng-show=\"pageloading.step == 2\"><img id=preloading-title-2 class=preloading-title src=assets/images/preloading-logo-title-2.jpg></div><div class=\"page-step yellow\" ng-show=\"pageloading.step == 1\"><img id=preloading-title-1 class=preloading-title src=assets/images/preloading-logo-title-1.jpg></div><div class=\"page-step yellow\" ng-show=\"pageloading.platform.phone && pageloading.step == 0\"><div class=\"preloading-logo preloading-yellow\">FFFM &amp; Vogue Italia present</div></div><div class=\"preloading-logo preloading-yellow\" ng-show=\"!pageloading.platform.mobile && pageloading.isLogo && pageloading.isYellow\">FFFM &amp; Vogue Italia present</div><div class=\"preloading-logo preloading-black\" ng-show=\"!pageloading.platform.mobile && pageloading.isLogo && !pageloading.isYellow\">FFFM &amp; Vogue Italia present</div><div class=spinner><div class=spinner-bg></div><div id=spinner-pixi class=spinner-circle></div></div></div>");}]);